/*
 * Decoribbo — birleşik varyant tablosu köprüsü
 *
 * Tablodaki satır seçildiğinde Dawn'ın gizli option radio'larını işaretler ve
 * change olayı gönderir. Varyant çözümlemesini tema kendi yapar; burada
 * hiçbir fiyat/stok mantığı yok.
 *
 * Olay delegasyonu kullanılıyor çünkü Dawn varyant değişiminde bölümün
 * HTML'ini yeniden basıyor ve doğrudan bağlanan dinleyiciler kopuyor.
 */
(function () {
  if (window.__decoribboVComboReady) return;
  window.__decoribboVComboReady = true;

  document.addEventListener('change', function (event) {
    const row = event.target.closest && event.target.closest('.custom-vcombo__input');
    if (!row) return;

    const host = row.closest('variant-selects');
    if (!host) return;

    const values = (row.dataset.optionValues || '').split('||');
    const fieldsets = host.querySelectorAll('fieldset');
    let lastTouched = null;

    values.forEach(function (value, index) {
      const fieldset = fieldsets[index];
      if (!fieldset) return;

      const match = Array.prototype.slice
        .call(fieldset.querySelectorAll('input[type="radio"]'))
        .find(function (input) {
          return input.value === value;
        });

      if (!match) return;
      if (!match.checked) match.checked = true;
      lastTouched = match;
    });

    if (lastTouched) {
      lastTouched.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
